import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from 'antd';
import 'antd/dist/reset.css';
import { TEXT_CONSTANTS } from '../../constants/Constants';


const UserType = () => {
  const {Paragraph,Title } = Typography;
  return (
    <div className="flex flex-col items-center">
      {/* Admin Login Button */}
      <Title level={2}>{TEXT_CONSTANTS.SUSTAINABILITY_LOGIN_TITLE}</Title>
      <Paragraph className="text-base font-semibold">
            {TEXT_CONSTANTS.SUSTAINABILITY_LOGIN_PROMPT}
      </Paragraph>
      
      <Link to={TEXT_CONSTANTS.ADMIN_LOGIN_URL}>
        <Button
          type="primary"
          size="large"
          className="w-[340px] h-[60px] rounded-full bg-[#1F405A] mt-2"
        >
          {TEXT_CONSTANTS.ADMIN_LOGIN_TEXT}
        </Button>
      </Link>

      {/* Supplier Login Button */}
      <Link to={TEXT_CONSTANTS.SUPPLIER_LOGIN_URL} className="mt-8">
        <Button
          type="primary"
          size="large"
          className="w-[340px] h-[60px] rounded-full bg-[#1F405A]"
        >
          {TEXT_CONSTANTS.SUPPLIER_LOGIN_TEXT}
        </Button>
      </Link>
    </div>
  );
};

export default UserType;
